import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...shorthands.margin("0rem", "0rem", "6.25rem", "0rem"),
    ...shorthands.gap("7.5rem"),
    "@media (max-width: 540px)": {
      width: "95%",
      ...shorthands.padding("0px", "0.75rem"),
      ...shorthands.margin("1rem", "0rem", "2.5rem", "0rem"),
    },
  },
});
